export default {
  error: 'Error 404',
  somethingWrong: '¡Oh no! Parece que algo salió mal',
  unavailablePage: 'La página que estabas buscando no se encuentra disponible',
  backToHome: 'Volver al inicio'
}

export const en = {
  error: '404 Error',
  somethingWrong: 'Oh no! Something went wrong',
  unavailablePage: 'The page you were searching for is not available',
  backToHome: 'Go back to home'
}

export const ca = {
  error: 'Error 404',
  somethingWrong: 'Vaja! Sembla que alguna cosa ha sortit malament',
  unavailablePage: 'La pàgina que estaves buscant no està disponible',
  backToHome: 'Torna a l\'inici'
}
